import { render, staticRenderFns } from "./questionBankPart.vue?vue&type=template&id=bd78e372&scoped=true&"
import script from "./questionBankPart.vue?vue&type=script&lang=js&"
export * from "./questionBankPart.vue?vue&type=script&lang=js&"
import style0 from "./questionBankPart.vue?vue&type=style&index=0&id=bd78e372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd78e372",
  null
  
)

export default component.exports